"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calculatePlacementAlignment;

var _constants = require("./constants");

/**
 * @param {Object} options - See definition in calculatePosition
 * @param {PopoverPositionContext} context - See definition in calculatePositionContext
 * @return {{ placement: string, alignment: string }}
 */
function calculatePlacementAlignment(options, context) {
  const desiredPlacement = options.placement;
  const desiredAlignment = options.alignment;
  const allowPlacementAxisChange = options.allowPlacementAxisChange === undefined ? true : options.allowPlacementAxisChange;
  let placement = desiredPlacement;
  let alignment = desiredAlignment;
  const spaceLeftOfAnchor = context.anchorRect.left - context.offsetFromEdge;
  const spaceRightOfAnchor = context.availableWidth - context.anchorRect.right - context.offsetFromEdge;
  const spaceAboveAnchor = context.anchorRect.top - context.offsetFromEdge;
  const spaceBelowAnchor = context.availableHeight - context.anchorRect.bottom - context.offsetFromEdge;
  const sufficientSpaceIfPlacedOnLeft = context.bodyElementWidthWithoutPadding + context.bodyOffsetFromAnchor <= spaceLeftOfAnchor;
  const sufficientSpaceIfPlacedOnRight = context.bodyElementWidthWithoutPadding + context.bodyOffsetFromAnchor <= spaceRightOfAnchor;
  const sufficientSpaceIfPlacedAbove = context.bodyElementHeightWithoutPadding + context.bodyOffsetFromAnchor <= spaceAboveAnchor;
  const sufficientSpaceIfPlacedBelow = context.bodyElementHeightWithoutPadding + context.bodyOffsetFromAnchor <= spaceBelowAnchor;

  if (desiredPlacement === _constants.PLACEMENT_TOP || desiredPlacement === _constants.PLACEMENT_BOTTOM) {
    if (desiredPlacement === _constants.PLACEMENT_BOTTOM && !sufficientSpaceIfPlacedBelow) {
      if (sufficientSpaceIfPlacedAbove) {
        return {
          placement: _constants.PLACEMENT_TOP,
          alignment
        };
      }

      if (allowPlacementAxisChange && sufficientSpaceIfPlacedOnLeft) {
        return {
          placement: _constants.PLACEMENT_LEFT,
          alignment: _constants.ALIGNMENT_CENTER
        };
      }

      if (allowPlacementAxisChange && sufficientSpaceIfPlacedOnRight) {
        return {
          placement: _constants.PLACEMENT_RIGHT,
          alignment: _constants.ALIGNMENT_CENTER
        };
      }

      if (spaceAboveAnchor > spaceBelowAnchor) {
        return {
          placement: _constants.PLACEMENT_TOP,
          alignment
        };
      }
    }

    if (desiredPlacement === _constants.PLACEMENT_TOP && !sufficientSpaceIfPlacedAbove) {
      if (sufficientSpaceIfPlacedBelow) {
        return {
          placement: _constants.PLACEMENT_BOTTOM,
          alignment
        };
      }

      if (allowPlacementAxisChange && sufficientSpaceIfPlacedOnLeft) {
        return {
          placement: _constants.PLACEMENT_LEFT,
          alignment: _constants.ALIGNMENT_CENTER
        };
      }

      if (allowPlacementAxisChange && sufficientSpaceIfPlacedOnRight) {
        return {
          placement: _constants.PLACEMENT_RIGHT,
          alignment: _constants.ALIGNMENT_CENTER
        };
      }

      if (spaceBelowAnchor > spaceAboveAnchor) {
        return {
          placement: _constants.PLACEMENT_BOTTOM,
          alignment
        };
      }
    }
  }

  if (desiredPlacement === _constants.PLACEMENT_LEFT || desiredPlacement === _constants.PLACEMENT_RIGHT) {
    if (desiredPlacement === _constants.PLACEMENT_LEFT && !sufficientSpaceIfPlacedOnLeft) {
      if (sufficientSpaceIfPlacedOnRight) {
        return {
          placement: _constants.PLACEMENT_RIGHT,
          alignment
        };
      }

      if (allowPlacementAxisChange && !sufficientSpaceIfPlacedBelow && sufficientSpaceIfPlacedAbove) {
        return {
          placement: _constants.PLACEMENT_TOP,
          alignment: _constants.ALIGNMENT_CENTER
        };
      }

      if (allowPlacementAxisChange) {
        return {
          placement: _constants.PLACEMENT_BOTTOM,
          alignment: _constants.ALIGNMENT_CENTER
        };
      }

      if (spaceRightOfAnchor > spaceLeftOfAnchor) {
        return {
          placement: _constants.PLACEMENT_RIGHT,
          alignment
        };
      }
    }

    if (desiredPlacement === _constants.PLACEMENT_RIGHT && !sufficientSpaceIfPlacedOnRight) {
      if (sufficientSpaceIfPlacedOnLeft) {
        return {
          placement: _constants.PLACEMENT_LEFT,
          alignment
        };
      }

      if (allowPlacementAxisChange && !sufficientSpaceIfPlacedBelow && sufficientSpaceIfPlacedAbove) {
        return {
          placement: _constants.PLACEMENT_TOP,
          alignment: _constants.ALIGNMENT_CENTER
        };
      }

      if (allowPlacementAxisChange) {
        return {
          placement: _constants.PLACEMENT_BOTTOM,
          alignment: _constants.ALIGNMENT_CENTER
        };
      }

      if (spaceLeftOfAnchor > spaceRightOfAnchor) {
        return {
          placement: _constants.PLACEMENT_LEFT,
          alignment
        };
      }
    }
  }

  return {
    placement,
    alignment
  };
}